import apiClient from '../apiClient'

export default {
  async getNotificationOptions(id) {
    return await apiClient.get(
      apiClient.url(
        '/users/legacy/{id}/energy-market/futures/notifications/options',
        { id: id },
      ),
    )
  },
  async saveNotificationOptions(id, data = {}) {
    return await apiClient.post(
      apiClient.url(
        '/users/legacy/{id}/energy-market/futures/notifications/options',
        { id: id },
      ),
      data,
    )
  },
  async getActiveFutures(params = {}) {
    return await apiClient.get(
      apiClient.url('/energy-market/futures/active'),
      params,
    )
  },
  async getFuturesData(params = {}) {
    return await apiClient.get(
      apiClient.url('/energy-market/futures/data'),
      params,
    )
  },
  async downloadExcelExport(params) {
    return await apiClient.download(
      apiClient.url('/energy-market/futures/data/export/excel'),
      params,
    )
  },
  async getOkteData(params = {}) {
    return await apiClient.get(
      apiClient.url('/energy-market/total-dam-results/by-date'),
      params,
    )
  },
}
